import { ArrowLeftIcon } from 'lucide-react'
import { useContext } from 'react'

import { membersMarketplace, publicMembersMarketplace } from 'rails_routes'

import { type MarketplaceProduct } from './types'

import { events, SessionContext } from '.'

export const Header = ({ product }: { product: MarketplaceProduct }) => {
  const member = useContext(SessionContext)
  const backHref = member.publicView ? publicMembersMarketplace.index() : membersMarketplace.index()
  return (
    <a
      href={backHref}
      onClick={() => events.emitBackClickEvent(member, product)}
      className='inline-flex items-center body text-gray-500 hover:text-gray-800 hover:underline'
    >
      <ArrowLeftIcon className='h-4 w-4 mr-1' />
      Back to Marketplace
    </a>
  )
}
